import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-field mb-1" }
const _hoisted_2 = { class: "p-field-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GuestItem = _resolveComponent("GuestItem")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("AppResourceEP.AddBadgesGuestSubtitle")), 1)
    ]),
    _createVNode(_component_ElScrollbar, { class: "card-list" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.guests, (guest, i) => {
          return (_openBlock(), _createBlock(_component_GuestItem, {
            key: i,
            class: "guest-card card--slim mx-3 my-2",
            guest: guest,
            onClick: ($event: any) => (_ctx.selectGuest(guest))
          }, null, 8, ["guest", "onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}